export const msalConfig = {
    auth: {
      clientId: "d0852b94-1ef4-453d-881d-5c50257ecd6e",
      authority: "https://login.microsoftonline.com/299a2881-1380-4020-b42f-715a35e1bcaf", // o el tenant específico
      redirectUri: "https://serviciosweb.konradlorenz.edu.co/digiturno"
      //redirectUri: "http://localhost:3000/digiturno"
    },
    cache: {
      cacheLocation: "localStorage", // o sessionStorage
      storeAuthStateInCookie: true
    }
  };
  
  export const loginRequest = {
    scopes: ["email","User.Read"] // puedes personalizarlo según tus necesidades
  };